import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { RecordRequestRouter } from 'components/routers';
import { ProgressBar, ReloadPageNotification } from 'components/ui';
import { RouterPrompt } from 'components/modals/Prompt'

import { recordRequestSelector } from 'store/reducers/recordRequest.reducer';
import { abandonedRecordRequest, draftRecordRequest, setRecordRequestReset } from 'store/actions/recordRequest.action';
import { dependentsSelector } from 'store/reducers/dependents.reducer';
import { dependentDeatils, dependentReset } from 'store/actions/dependents.action';
import moment from 'moment';
import { authSelector } from 'store/reducers/auth.reducer';
import { filesToBase64 } from 'utils';
import path from 'path'

const whitelist = ['/record-request/provider', '/record-request/patient', '/record-request/create-patient', '/record-request/date', '/record-request/auth-type', '/record-request/authorization', '/record-request/govt-id', '/record-request/supporting-docs', '/record-request/request-info', '/record-request/payment', '/record-request/add-payment', '/record-request/confirm', '/record-request/requestConfirmed']

export const RecordRequestLayout = () => {
  const dispatch = useDispatch();
  const { currentStep, showPrompt, total, ...request } = useSelector(recordRequestSelector);
  const { detailed } = useSelector(dependentsSelector)
  const { profile } = useSelector(authSelector)

  useEffect(() => {
    return () => {
      dispatch(setRecordRequestReset());
    };
  }, [dispatch]);

  useEffect(() => {
    if (request.patientId) {
      if(!detailed){
        dispatch(dependentDeatils(request.patientId));
      }else if (detailed.id != request.patientId)
      { dispatch(dependentDeatils(request.patientId));
      }
    }
  }, [request.patientId])
  
  useEffect(() => {
    if ((currentStep == 2 && !request.rid)) {
      handleSave('draft', (err, message) => {})
    }
  }, [currentStep])
  const selectedLocation = request.provider?.selectedLocation
  const handleSave = async (status: string, callback?: (error: boolean, message: string) => void) => {
    let patientInfo = request.patientInfo || { dependent_id: request.patientId || '' };
    let data = {
      ...patientInfo,
      custodian_id: `${request.provider?.id}`,
      card_id: request.paymentMethod !== 'check' && request.payment || '',
      all_records: request.date?.allRecords ? true : undefined,
      records_before: request.date?.recordsBefore || '',
      records_after: request.date?.recordsAfter || '',
      // is_upload_authorization: request.authType == 'GeneralRelease',
      initials: request.estimateInitials,
      check_payment: request.paymentMethod == 'check',
      delivery_method: request.requestDetails?.deliveryMethod,
      scope: request.requestDetails?.recordType?.map(item => item.value),
      reason_for_request: request.requestDetails?.reasonForRequest?.map(item => item.value),
      rush_request: request.requestDetails?.rushRequest,
      rid: request.rid,
      status,
      current_step: currentStep,
      selected_location: selectedLocation
    }

    if (request?.govtId?.frontFileId && data.frontFile) data.frontFileId = request?.govtId?.frontFileId;
    if (request?.govtId?.frontFileId && data.frontFile) data.frontType = 'front';
    if (request?.govtId?.backFileId && data.backFile) data.backFileId = request?.govtId?.backFileId;
    if (request?.govtId?.backFileId && data.backFile) data.backType = 'back'

    if (request.requestDetails?.deliveryMethod == 'fax-return') {
      data.fax_number = request.requestDetails.faxNumber
      data.recipient_name = request.requestDetails.recipientName
      data.recipient_type = request.requestDetails.recipientType?.value
      data.remark = request.requestDetails.remark
    }
    const signature = request.auth?.signature ? (await filesToBase64([request.auth?.signature])) : ''
    let fd = new FormData()
    for (let key in data) fd.append(key, data[key] || '')
    fd.append('auth_name', request.auth?.fullName || '')
    fd.append('auth_initials', request.auth?.initials || '')
    fd.append('auth_dob', request.auth?.birthday ? moment(request.auth?.birthday).format(process.env.REACT_APP_DATE_FORMAT) : moment().format(process.env.REACT_APP_DATE_FORMAT))
    fd.append('auth_ssn', request.auth?.ssn ? request.auth?.ssn.replace('-', '').replace('-', '') : '')
    fd.append('auth_role', request.auth?.iAmThe || '')
    fd.append('auth_extra_field', request.auth?.extraField || '')
    fd.append('auth_extra_value', request.auth?.extraValue || '')
    fd.append('auth_signature', signature)
    fd.append('auth_signature_id', '1234')
    fd.append('auth_print_name', request.auth?.fullName || '')
    fd.append('auth_date', moment().format(process.env.REACT_APP_DATE_FORMAT))
    fd.append('release_sensitive_info', (request?.auth?.sensitiveInformation))
    fd.append('sensitive_info', JSON.stringify(request?.auth?.sensitiveOptions))
   // if (request.authType == 'GeneralRelease') {
    if (request?.auth?.generalReleaseFile) fd.append('authorization[][document]', request.auth.generalReleaseFile)
    // }
    if(request?.auth?.generalReleaseFile && request.auth?.signature || request?.auth?.generalReleaseFile){
      data.is_upload_authorization = true
    }else{
      data.is_upload_authorization = false
    }
    fd.append('is_upload_authorization', data.is_upload_authorization)

    if (request.govtId?.frontFile) fd.append('frontFile', request.govtId?.frontFile, `${profile?.name || ''}_front${path.extname(request.govtId?.frontFile.name)}`)
    if (request.govtId?.backFile) fd.append('backFile', request.govtId?.backFile, `${profile?.name || ''}_back${path.extname(request.govtId?.backFile.name)}`)
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    request.supportingDocs?.filter(doc => doc.deleted || doc.suppFile).forEach((doc, i) => {
      fd.append(`supporting_docs[document][${i}]`, doc.suppFile || JSON.stringify({ id: doc.fileId }))
    })
    if (request?.auth?.generalReleaseFile) fd.append('authorization[][document]', request.auth.generalReleaseFile)
    dispatch(status == 'draft' ? draftRecordRequest(fd, callback) : abandonedRecordRequest(fd));
    dispatch(dependentReset());
    localStorage.setItem('language','en')
    return true
  }

  return (
    <>
      <RouterPrompt
        when={showPrompt || false}
        title='Exiting Record Request Process'
        description={[`You are about to exit the record request process and your request for the records of`, `${request.patientInfo?.patient_first_name || detailed?.firstName || profile?.name} will be abandoned.`]}
        okText='Abandon'
        onOk={() => handleSave('abandoned')}
        cancelText='Continue'
        onCancel={() => null}
        otherOkText='Save as Draft'
        otherOnOk={() => handleSave('draft')}
        whitelist={whitelist}
        hideOk={['Retrieval', 'Retrieval - Former Client'].includes(request?.provider?.service_level)}
      />

      {currentStep > 1 && <ReloadPageNotification />}
      <ProgressBar total={total} current={currentStep} />
      <RecordRequestRouter curruntStep={currentStep} total={total} />
    </>
  );
};
